import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const NAV = [
    { to: "/materials", label: "Research Materials" },
    { to: "/standards", label: "Our Standards" },
    { to: "/testing", label: "Testing & COAs" },
    { to: "/about", label: "About" },
    { to: "/faq", label: "FAQ" },
    { to: "/contact", label: "Contact" },
];

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-surface2 border-t border-stone-200">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <img
                            src="/assets/grayhaven-logo-dna.png"
                            alt="Grayhaven Research"
                            className="w-44"
                            data-testid="footer-logo"
                        />
                        <p className="mt-6 font-serif text-xl italic text-slate-600">
                            “Quality. Transparency. Integrity. Research with confidence.”
                        </p>
                        <a
                            href="mailto:hello@grayhavenresearch.com"
                            data-testid="footer-email-link"
                            className="mt-6 inline-flex items-center gap-2 text-sm text-mist hover:text-wine transition-colors duration-300"
                        >
                            <Mail className="h-4 w-4 text-gold" />
                            hello@grayhavenresearch.com
                        </a>
                    </div>

                    <div className="md:col-span-3">
                        <p className="eyebrow mb-6">Navigate</p>
                        <ul className="space-y-3">
                            {NAV.map((link) => (
                                <li key={link.to}>
                                    <Link
                                        to={link.to}
                                        data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                        className="text-sm text-mist hover:text-wine transition-colors duration-300"
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <p className="eyebrow mb-6">Legal</p>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/privacy" data-testid="footer-privacy-link" className="text-sm text-mist hover:text-wine transition-colors duration-300">
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link to="/research-use" data-testid="footer-research-use-link" className="text-sm text-mist hover:text-wine transition-colors duration-300">
                                    Research Use Policy
                                </Link>
                            </li>
                            <li>
                                <Link to="/terms" data-testid="footer-terms-link" className="text-sm text-mist hover:text-wine transition-colors duration-300">
                                    Terms &amp; Conditions
                                </Link>
                            </li>
                        </ul>
                        <p className="mt-8 text-xs leading-relaxed text-slate-500" data-testid="footer-disclaimer">
                            All materials are supplied strictly for laboratory research use only. Not for human or
                            veterinary use. Nothing on this website constitutes medical advice.
                        </p>
                    </div>
                </div>

                <div className="gold-hairline mt-16" />
                <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs tracking-[0.2em] uppercase text-slate-500">
                        © {new Date().getFullYear()} Grayhaven Research
                    </p>
                    <p className="text-xs tracking-[0.2em] uppercase text-slate-500">Research Use Only</p>
                </div>
            </div>
        </footer>
    );
}
